module.exports = kolibriGlobal.coreVue.components.LanguageSwitcherList;